/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal, Skeleton, Empty, Form, message, Button } from 'antd'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { getAge } from '../../constants/helper'
import { RoleCode } from '../../constants'

import ConstituentAvatar from '../../components/Custom/ConstituentAvatar'
import AvatarUpload from '../../components/Custom/AvatarUpload'
import EditConstituent from '../ResidentProfile/Constituents/addForm'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isFormShown: false,
			isEdit: false,
			selectedConstituent: null
		}

		this.handleUploadAvatar = this.handleUploadAvatar.bind(this)
	}

	handleUploadAvatar(data) {
		const { constituent_uid, uploadAvatar } = this.props
		const { fileList } = data

		console.log('fileList', fileList)
		const formattedFiles = fileList.map((mFile) => mFile.originFileObj).filter((i) => i !== undefined)
		const files = []
		if (formattedFiles.length > 0) {
			files.push(formattedFiles[formattedFiles.length - 1])
		}

		const params = {
			constituent_uid,
			files
		}
		uploadAvatar(params)
			.then(resp => {
				message.success('Avatar successfully updated')
			})
			.catch(err => {
				console.log('error uploading avatar', err)
				message.error(err.message.replace('GraphQL error:', ''))
			})
	}

	render() {
		const { isFormShown, isEdit, selectedConstituent } = this.state
		const { visible, onCancel, constituent_uid, table_name, AuthStore, form, fromDTR } = this.props
		const { getFieldDecorator } = form
		const { user_type } = AuthStore
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))

    	return (
    		<React.Fragment>
				 <Modal
    				width='90%'
    				visible={visible}
    				title='View Details'
    				onCancel={onCancel}
    				destroyOnClose
					footer={null}
    			>
					<Query 
						query={CONSTITUENT_BY_UID} 
						variables={{ constituent_uid, table_name }}
						fetchPolicy='network-only'
					>
						{({ loading, error, data }) => {
							if (loading) return <Skeleton active/>
							if (error) return <Empty />

							let constituent = _.has(data,'barangayConstituentByUid') ? data.barangayConstituentByUid : {}
							//console.log('constituent', constituent)
							
							return (
								<React.Fragment>
									{
										!isAdmin &&
										<Row style={{ marginTop: 15, marginBottom: 40 }} type='flex' justify='center'>
											<ConstituentAvatar size={100}  constituent_uid={constituent.uid}/>
										</Row>
									}
									{
										isAdmin &&
										<Form>
											<Row style={{ marginTop: 15, marginBottom: 40 }} type='flex' justify='center'>
												<Form.Item label=''>
													{ getFieldDecorator('avatar', {
														rules: [{
															required: true,
															message: 'This field is required.'
														}]
													})
													(
														<AvatarUpload constituent_uid={constituent ? constituent.uid : null} onChange={this.handleUploadAvatar} />
													)}
												</Form.Item>
											</Row>
										</Form>
									}
									{
										(isAdmin && fromDTR) &&
										<Row style={{ marginTop: -30, marginBottom: 5 }} type='flex' justify='center'>
											<Button type='ghost' onClick={() => {
												this.setState({ isFormShown: true, isEdit: true, selectedConstituent: constituent })
											}}>Edit Details</Button>
										</Row>
									}
									<Row className='constituent-details-container'>
										<legend>Demography</legend>
										<Row>
											{
												constituent.id_number &&
												<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
													<label>ID Number</label>
													<h4>{constituent.id_number || '- - -'}</h4>
												</Col>
											}
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Household Number</label>
												<h4>{constituent.household_no || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>First Name</label>
												<h4>{constituent.first_name || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Middle Name</label>
												<h4>{constituent.middle_name || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Last Name</label>
												<h4>{constituent.last_name || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Gender</label>
												<h4>{constituent.gender || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Birthday</label>
												<h4>{moment(constituent.birthday).format('ll')}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Age</label>
												<h4>{getAge(moment(constituent.birthday))}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Civil Status</label>
												<h4>{constituent.civil_status || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Contact Number</label>
												<h4>{constituent.contact_no || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Citizenship</label>
												<h4>{constituent.citizenship || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Birth Place</label>
												<h4>{constituent.birth_place || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Residency Type</label>
												<h4>{constituent.residency_ownership || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Resident Since</label>
												<h4>{moment(constituent.residency_date).format('ll')}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Nuclear Family</label>
												<h4>{constituent.nuclear_family || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Household Type</label>
												<h4>{constituent.relation_in_head || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Other Relation</label>
												<h4>{constituent.others_relation_in_head || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Religion</label>
												<h4>{(constituent.other_religion) ? constituent.other_religion : (constituent.religion) ? constituent.religion : '- - -'}</h4>
											</Col>
										</Row>
									</Row>
									<Row className='constituent-details-container'>
										<legend>Address</legend>
										<Row gutter={16}>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>House Number</label>
												<h4>{constituent.house_no || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Block</label>
												<h4>{constituent.block || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Lot</label>
												<h4>{constituent.lot || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Street</label>
												<h4>{constituent.street || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Sitio/Subdivision</label>
												<h4>{constituent.address || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Purok</label>
												<h4>{constituent.purok_name || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Purok Leader</label>
												<h4>{constituent.purok_leader || '- - -'}</h4>
											</Col>
										</Row>
									</Row>
									<Row className='constituent-details-container'>
										<legend>Education</legend>
										<Row>
											<Col md={5} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Schooling</label>
												<h4>{constituent.schooling || '- - -'}</h4>
											</Col>
											<Col md={5} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>School Type</label>
												<h4>{constituent.school_type || '- - -'}</h4>
											</Col>
											<Col md={4} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Year Level</label>
												<h4>{constituent.year_level || '- - -'}</h4>
											</Col>
											<Col md={5} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Course</label>
												<h4>{constituent.course || '- - -'}</h4>
											</Col>
											<Col md={5} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Highest Educational Attainment</label>
												<h4>{constituent.educational_attainment || '- - -'}</h4>
											</Col>
										</Row>
									</Row>
									<Row className='constituent-details-container'>
										<legend>Health</legend>
										<Row>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>PWD</label>
												<h4>{constituent.pwd || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Disability Type</label>
												<h4>{constituent.disability_type || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Other Disability</label>
												<h4>{constituent.other_disability || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>With PWD ID?</label>
												<h4>{constituent.with_pwd_id || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>With Senior ID?</label>
												<h4>{constituent.with_senior_id || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Pregnant</label>
												<h4>{constituent.pregnant || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Teenage Pregnancy?</label>
												<h4>{constituent.is_teenage_pregnancy || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Solo Parent?</label>
												<h4>{constituent.solo_parent || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Height (in meters)</label>
												<h4>{constituent.height || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Weight (in kilograms)</label>
												<h4>{constituent.weight || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Nutritional Status</label>
												<h4>{constituent.nutritional_status || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Chronic disease</label>
												<h4>{constituent.illness || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Other Chronic disease</label>
												<h4>{constituent.other_illness || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Respiratory Issue</label>
												<h4>{constituent.respiratory_issue || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Other respiratory Issue</label>
												<h4>{constituent.other_respiratory_issue || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Maternal Death</label>
												<h4>{constituent.maternal_death || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Covid Contacted</label>
												<h4>{constituent.contacted_covid || '- - -'}</h4>
											</Col>
										</Row>
									</Row>
									<Row className='constituent-details-container'>
										<legend>Employment</legend>
										<Row>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>OFW</label>
												<h4>{constituent.ofw || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Employed</label>
												<h4>{constituent.employed || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>With Business?</label>
												<h4>{constituent.with_business || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Occupation Code</label>
												<h4>{constituent.occupation_code || '- - -'}</h4>
											</Col>
											{
												constituent.occupation_others &&
												<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
													<label>Occupation Others</label>
													<h4>{constituent.occupation_others || '- - -'}</h4>
												</Col>
											}
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Industrial Code</label>
												<h4>{constituent.industry_code || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Class of Worker</label>
												<h4>{constituent.class_of_worker || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Nature of Employment</label>
												<h4>{constituent.nature_of_employment || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Activity/occupation during past 3 months</label>
												<h4>{constituent.activity_past_3mos || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Province/City/Municipality did work past 3 months</label>
												<h4>{constituent.where_work_past_3mos || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Total Salary (Peso)</label>
												<h4>{constituent.total_salary_peso || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Total Salary (Goods)</label>
												<h4>{constituent.total_salary_goods || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Looking for Job?</label>
												<h4>{constituent.looking_for_job || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center', marginTop: 20 }}>
												<label>Reason why not looking for Job?</label>
												<h4>{constituent.reason_not_looking_job || '- - -'}</h4>
											</Col>
										</Row>
									</Row>
									<Row className='constituent-details-container'>
										<legend>Other Details</legend>
										<Row>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>4P's Member?</label>
												<h4>{constituent.experienced_hunger || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Victim of Crime?</label>
												<h4>{constituent.victim_of_crime || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Type of Crime</label>
												<h4>{constituent.type_of_crime || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Other Crime</label>
												<h4>{constituent.other_crime || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Living?</label>
												<h4>{(constituent.is_alive) == 1 ? 'YES' : 'DECEASED'}</h4>
											</Col>
										</Row>
									</Row>
									<Row className='constituent-details-container'>
										<legend>Voter's Details</legend>
										<Row>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Voter's ID</label>
												<h4>{constituent.voters_id || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Precint Number</label>
												<h4>{constituent.precint_no || '- - -'}</h4>
											</Col>
											<Col md={6} sm={24} className='constituent-details' style={{ textAlign: 'center' }}>
												<label>Registered Voter?</label>
												<h4>{constituent.registered_voter || '- - -'}</h4>
											</Col>
										</Row>
									</Row>
								</React.Fragment>
							)
						}}
					</Query>
    			</Modal>
				{
					isFormShown &&
					<EditConstituent
						isEdit={isEdit}
						selectedConstituent={selectedConstituent}
						visible={isFormShown}
						onClose={() => this.setState({ isFormShown: false, isEdit: false, selectedConstituent: null })}
					/>
				}
    		</React.Fragment>
    	)
	}
}

const CONSTITUENT_BY_UID = gql`
    query barangayConstituentByUid($constituent_uid: String, $table_name: String) {
		barangayConstituentByUid(constituent_uid: $constituent_uid, table_name: $table_name)
    }
`

const UPLOAD_AVATAR = gql`
    mutation uploadConstituentAvatar($input: JSON) {
		uploadConstituentAvatar(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-update-avatar' }),
	inject('AuthStore'),
	graphql(UPLOAD_AVATAR, {
		props({ mutate }) {
			return {
				uploadAvatar(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['barangayConstituentByUid','constituentAvatar']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
